import { FC, useEffect } from 'react'
import { useNavigate } from 'react-router-dom'

const EditCompany: FC = () => {
  const navigate = useNavigate()

  useEffect(() => {
    const searchParams = new URLSearchParams(window.location.search)
    const companyId = searchParams.get('companyId')

    navigate(companyId ? `/company?companyId=${companyId}&edit=true` : '/companies', { replace: true })
  }, [navigate])

  return null
}

export default EditCompany
